import React from 'react';

const ChevronRightIcon = (props: any) => (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1 1.00006L5 5.00235L0.999998 9.00006"
      stroke={props.color ? props.color : '#1F221F'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronRightIcon;
